import * as React from "react";
import { House, Building2, CloudLightning, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const expertiseData = [{
  title: "Operational Efficiency",
  description: "We streamline your internal workflows to eliminate bottlenecks and maximize productivity, leveraging a decade of consulting excellence.",
  icon: House,
  link: "/ConsultationPage"
}, {
  title: "Cost Optimization",
  description: "Our analytical approach identifies unnecessary expenditures, allowing you to reallocate resources toward high-growth business initiatives.",
  icon: Building2,
  link: "/ConsultationPage"
}, {
  title: "Revenue Expansion",
  description: "Implement strategic scaling frameworks designed to capture market share and drive sustainable top-line performance for your enterprise.",
  icon: CloudLightning,
  link: "/ConsultationPage"
}];
export default function OurRoofingExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="31863" id="our-strategic-pillars" ref={ref} className={cn("bg-background text-foreground py-20 lg:py-32 transition-opacity duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-[60px]">
          {expertiseData.map((item, i) => <Card key={i} data-index={i} className="group bg-card border border-border hover:border-ring transition-colors duration-300 shadow-none rounded-sm h-full flex flex-col">
              <CardHeader className="pt-8 px-8 pb-4">
                <div className="mb-6 inline-flex items-center justify-center">
                  <item.icon strokeWidth={1.5} className="w-12 h-12 text-ring" />
                </div>
                <CardTitle className="font-sans text-2xl font-bold tracking-tight text-foreground">
                  {item.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="px-8 pb-8 flex-grow">
                <p className="font-sans text-muted-foreground leading-relaxed">
                  {item.description}
                </p>
              </CardContent>
              <CardFooter className="px-8 pb-8 pt-0">
                <Link to={item.link} className="inline-flex items-center text-sm font-semibold text-ring hover:text-ring/80 transition-colors group-hover:translate-x-1 duration-300">
                  Learn More
                  <ChevronRight className="ml-1 w-4 h-4" />
                </Link>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}